import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Tooltip } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import SecurityIcon from '@mui/icons-material/Security';
import { Card } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';

const UserGroupsComponent = ({ authUserData }) => {
  const { t } = useTranslation();

  return (
    <Card id='UserGroups_IconCard' icon={GroupIcon} title={t('Profile.UserGroups')}>
      <Grid container spacing={1}>
        {authUserData?.userGroups?.map((group, index) => (
          <Grid item xs={12} sm={4} key={index}>
            {group.isAdmin ? (
              <FormControlLabel
                readOnly
                control={
                  <Tooltip title={t('Profile.IsAdmin')}>
                    <SecurityIcon />
                  </Tooltip>
                }
                label={group.userGroupName}
                labelPlacement='start'
              />
            ) : (
              group.userGroupName
            )}
          </Grid>
        ))}
      </Grid>
    </Card>
  );
};

UserGroupsComponent.propTypes = {
  authUserData: PropTypes.object
};

export default UserGroupsComponent;
